<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Transactions</div>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-xs-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-xs-6">
            <div class="pull-right">
              <label>
                <input type="search" class="form-control input-sm" placeholder="Search transactions" v-model="searchQuery" aria-controls="datatables">
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :width="column.width"
                              :fixed="column.fixed"
                              :show-overflow-tooltip="true"
                              :prop="column.prop"
                              :label="column.label"
                              :formatter="column.formatter">
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
          <div v-if="to === total">
            You've reached the end of your account activity.  If you have older account activity that is not shown, please contact Providence First Trust Company.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import moment from 'moment'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        console.log(this.$store.state.userData)
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (key === 'TransDate') {
                rowValue = this.moment(rowValue).format('MM/DD/YYYY')
              }
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {
          perPage: 15,
          currentPage: 1,
          perPageOptions: [5, 10, 15, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['TransDate', 'TransAmount', 'TransPayee'],
        tableColumns: [
          {
            prop: 'TransDate',
            label: 'Date',
            width: 110,
            formatter: (row, column, cellValue) => {
              return (this.moment(cellValue).format('MM/DD/YYYY'))
            }
          },
          {
            prop: 'TransPayee',
            label: 'Description',
            minWidth: 200
          },
          {
            prop: 'TransAmount',
            label: 'Amount',
            fixed: 'right',
            minWidth: 100,
            formatter: (row, column, cellValue) => {
              return (Math.round(parseFloat(cellValue) * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
            }
          }
        ],
        tableData: this.$store.state.userData.transactions
        ? (this.$store.state.userData.clientData.GroupId === 1
            ? this.$store.state.userData.transactions.filter((transaction) => transaction.TransType !== 'MK' && moment(transaction.TransDate, 'YYYY-MM-DD').isSameOrAfter(moment('2014/01/01', 'YYYY-MM-DD')))
            : this.$store.state.userData.transactions.filter((transaction) => transaction.TransType !== 'MK')
           )
        : []
      }
    },
    methods: {

    }
  }
</script>
<style>

.el-table .cell {
  word-break: normal;
  overflow-wrap: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Transactions.vue